/**
 * 商城等API
 */
import request from '../setup/request';
const mall = {
  /**
   * 获取客户端YOOX主页配置信息
   */
  getYOOXMainPage(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.clientpage.getYooxPage',
    });
  },
  /**
   * 获取首页推荐的商品列表
   */
  getStoreAllGoodsList(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.goods.getStoreAllGoodsList',
    });
  },
  /**
   * 获取商品详情
   */
  getGoodsDetail(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.goods.getGoodsDetailForYoox',
    });
  },
  /**
   * 获取所有分类名称列表
   */
  getAllNames(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.gcategory.getAllNames',
    });
  },
  /**
   * 根据品牌ID和分类ID获取商品列表
   */
  getGoodsByIdList(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.goods.getGoodsByIdList',
    });
  },
  /**
   * 提交商品订单
   */
  getSubmitOrder(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.submitOrderS',
    });
  },
  /**
   * 根据类型查询订单列表
   */
  getOrderListWithGoods(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.getOrderListWithGoods',
    });
  },
  /**
   * 删除订单
   */
  getDeleteOrder(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.deleteOrder',
    });
  },
  /**
   * 取消订单
   */
  getCancelOrder(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.cancelOrder',
    });
  },
  /**
   * 提醒发货
   */
  getRemindOrder(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.remindOrder',
    });
  },
  /**
   * 确认收货
   */
  getTakeOverOrder(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.takeOverOrder',
    });
  },
  /**
   * mall订单详情
   */
  getOrderDetail(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.getOrderDetail',
    });
  },
  /**
   * 获取订单状态详细接口
   */
  getOrderLogList(params) {
    return request.post('', {
      ...params,
      method: 'ih.allcmall.order.getOrderLogList',
    });
  },
};
export default mall;
